import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";
import toast from "react-hot-toast";

const initialState = {
  shippingInfo: null,
  loading: false,
  errorMessage: null,
};

// ✅ Async thunk: Fetch shipping info by emirate
export const fetch_shipping_info = createAsyncThunk(
  "shipping/fetch_shipping_info",
  async ({ emirate, totalPrice, FREE_SHIPPING_THRESHOLD }, { rejectWithValue }) => {
    try {
      const res = await api.get(`/shipping/shipping-info?emirate=${emirate}`);
      let { cost, estimatedDelivery } = res.data;

      // Apply free delivery condition
      if (totalPrice >= FREE_SHIPPING_THRESHOLD) {
        cost = 0;
      }

      return { cost, estimatedDelivery };
    } catch (error) {
      const msg = error.response?.data?.error || "Shipping info not found";
      toast.error(msg);
      return rejectWithValue(msg);
    }
  }
);

// ✅ Slice
const shippingSlice = createSlice({
  name: "shipping",
  initialState,
  reducers: {
    clearShippingInfo: (state) => {
      state.shippingInfo = null;
      state.errorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetch_shipping_info.pending, (state) => {
        state.loading = true;
        state.errorMessage = null;
      })
      .addCase(fetch_shipping_info.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.shippingInfo = payload;
      })
      .addCase(fetch_shipping_info.rejected, (state, { payload }) => {
        state.loading = false;
        state.errorMessage = payload;
        state.shippingInfo = null;
      });
  },
});

export const { clearShippingInfo } = shippingSlice.actions;
export default shippingSlice.reducer;
